var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 186.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#231f20;}.cls-1,.cls-13,.cls-2,.cls-3{fill-rule:evenodd;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#231f20;}.cls-10,.cls-12,.cls-13,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-3,.cls-6,.cls-7,.cls-9{stroke-miterlimit:2.61;}.cls-2{stroke-width:0.28px;}.cls-3{stroke:#fff;stroke-width:0.22px;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-10,.cls-11,.cls-20,.cls-21,.cls-22,.cls-4,.cls-5,.cls-8,.cls-9{stroke-linecap:round;}.cls-11,.cls-14,.cls-20,.cls-21,.cls-22,.cls-4,.cls-5,.cls-8{stroke-linejoin:round;}.cls-4{stroke-width:1.98px;}.cls-12,.cls-5{stroke-width:1.94px;}.cls-6{stroke-width:3.05px;}.cls-7{stroke-width:3.09px;}.cls-8{stroke-width:1.94px;}.cls-9{stroke-width:3.03px;}.cls-10{stroke-width:3.06px;}.cls-11{stroke-width:1.15px;}.cls-13{fill:#fff;}.cls-13,.cls-14,.cls-15{stroke-width:1.94px;}.cls-16{stroke-width:1.92px;}.cls-17{stroke-width:1.43px;}.cls-18{stroke-width:2.27px;}.cls-19{stroke-width:2.27px;}.cls-20{stroke-width:1.94px;}.cls-21{stroke-width:1.94px;}.cls-22{stroke-width:1.94px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BMEKicsi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kicsi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M428.36,11.65V9.93h.79V5l.34-1.88.9-3.15.89,3.15L431.63,5v4.9h.79v1.72l8.71,26.75a8.8,8.8,0,0,0-.92,3.32H420.55a8.68,8.68,0,0,0-.92-3.3l8.73-26.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "294.6 71.18 290.01 71.18 289.45 67.05 289.45 66.29 295.16 66.29 295.16 67.05 294.6 71.18 294.6 71.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.4,79.48a6.12,6.12,0,0,0-1.56-1.15h0a9.13,9.13,0,0,0-8,0h0a6.12,6.12,0,0,0-1.56,1.15h0A3.71,3.71,0,0,0,297.22,82h0v24.34h13.24V82h0a3.62,3.62,0,0,0-1.06-2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "317.68 71.18 313.09 71.18 312.53 67.05 312.53 66.29 318.24 66.29 318.24 67.05 317.68 71.18 317.68 71.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M332.48,79.48a6.12,6.12,0,0,0-1.56-1.15h0a9.13,9.13,0,0,0-8,0h0a6.12,6.12,0,0,0-1.56,1.15h0A3.62,3.62,0,0,0,320.3,82h0v24.34h13.24V82h0a3.66,3.66,0,0,0-1.06-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.56,79.48A6.3,6.3,0,0,0,354,78.33h0a9.16,9.16,0,0,0-8,0h0a6.07,6.07,0,0,0-1.55,1.15h0A3.67,3.67,0,0,0,343.37,82h0v24.34h13.25V82h0a3.71,3.71,0,0,0-1.06-2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "340.75 71.18 336.17 71.18 335.61 67.05 335.61 66.29 341.32 66.29 341.32 67.05 340.75 71.18 340.75 71.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M378.63,79.48a6.07,6.07,0,0,0-1.55-1.15h0a9.16,9.16,0,0,0-8,0h0a6.12,6.12,0,0,0-1.56,1.15h0A3.71,3.71,0,0,0,366.45,82h0v24.34H379.7V82h0a3.67,3.67,0,0,0-1.07-2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "363.83 71.18 359.25 71.18 358.68 67.05 358.68 66.29 364.39 66.29 364.39 67.05 363.83 71.18 363.83 71.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401.71,79.48a6.12,6.12,0,0,0-1.56-1.15h0a9.13,9.13,0,0,0-8,0h0a6.12,6.12,0,0,0-1.56,1.15h0A3.71,3.71,0,0,0,389.53,82h0v24.34h13.24V82h0a3.62,3.62,0,0,0-1.06-2.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "386.91 71.18 382.32 71.18 381.76 67.05 381.76 66.29 387.47 66.29 387.47 67.05 386.91 71.18 386.91 71.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "409.98 71.18 405.4 71.18 404.84 67.05 404.84 66.29 410.55 66.29 410.55 67.05 409.98 71.18 409.98 71.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "400.02 126.4 400.02 132.79 392.72 132.79 392.72 126.4 400.02 126.4 400.02 126.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "401.18 116.31 401.18 120.61 391.57 120.61 391.57 116.31 401.18 116.31 401.18 116.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.44,124.75v-2.26h0a6.51,6.51,0,0,0-13,0h0V133.3l.08.11v4.37h12.89v-4.37l.07-.07v-8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.51,125.13v-2.26h0a6.51,6.51,0,0,0-13,0h0V133.3l.08.11v4.37h12.88v-4.37l.07-.07v-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.59,125v-2.26h0a6.51,6.51,0,1,0-13,0h0V133.3l.08.11v4.37h12.89v-4.37l.07-.07V125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.8,48.23c0-5.53-9.29-5.42-9.29,0H377.72c0-5.31-9.29-5.28-9.29,0H354.65c0-5.28-9.3-5.36-9.3,0l-13.78,0c0-5.25-9.29-5.28-9.29,0H308.49c0-5.21-9.29-5.29-9.29,0H285.61V43.44h3.23l22-25.35,2.35-3.17,0,0,0,0-.21,0h0V9.41h0a3.51,3.51,0,0,1,.34-1.56h0a1.79,1.79,0,0,1,1.13-1h0l.27,0,.28,0h0a1.79,1.79,0,0,1,1.12,1h0a3.39,3.39,0,0,1,.35,1.56h0V14.1h67.08V9.41h0a3.39,3.39,0,0,1,.35-1.56h0a1.79,1.79,0,0,1,1.13-1h0l.28,0,.27,0h0a1.79,1.79,0,0,1,1.13,1h0A3.51,3.51,0,0,1,387,9.41h0v5.48h-.19v0h0l2.43,3.17,21.91,25.37h3.27l0,4.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "307.28 126.6 307.28 132.79 299.98 132.79 299.98 126.6 307.28 126.6 307.28 126.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "308.43 116.31 308.43 120.61 298.82 120.61 298.82 116.31 308.43 116.31 308.43 116.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.64,11.65V9.93h-.79V5l-.34-1.88L269.61,0l-.89,3.15L268.37,5v4.9h-.79v1.72l-8.72,26.79a8.45,8.45,0,0,1,.94,3.28h19.66a9,9,0,0,1,.92-3.25l-8.74-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.56,78.08a2.36,2.36,0,0,0-4.34,0h0v8.83h4.34V78.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.42,78.08a2.36,2.36,0,0,0-4.34,0h0v8.83h4.34V78.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.78,78.08c-.81-2-3.85-2-4.34,0h0v8.83h4.34V78.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.64,78.08c-.81-2-3.85-2-4.33,0h0v8.83h4.33V78.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.46,78.08a2.35,2.35,0,0,0-4.34,0h0v8.83h4.34V78.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.32,78.08a2.35,2.35,0,0,0-4.34,0h0v8.83h4.34V78.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "259.22 94.91 259.22 104.48 263.56 104.48 263.56 94.91 259.22 94.91 259.22 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "420.08 94.91 420.08 104.48 424.42 104.48 424.42 94.91 420.08 94.91 420.08 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.44 94.91 267.44 104.48 271.78 104.48 271.78 94.91 267.44 94.91 267.44 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "428.31 94.91 428.31 104.48 432.64 104.48 432.64 94.91 428.31 94.91 428.31 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.12 94.91 275.12 104.48 279.46 104.48 279.46 94.91 275.12 94.91 275.12 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "435.98 94.91 435.98 104.48 440.32 104.48 440.32 94.91 435.98 94.91 435.98 94.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "259.24 116.09 259.24 126 263.57 126 263.57 116.09 259.24 116.09 259.24 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "420.1 116.09 420.1 126 424.44 126 424.44 116.09 420.1 116.09 420.1 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.44 116.09 267.44 126 271.78 126 271.78 116.09 267.44 116.09 267.44 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "428.31 116.09 428.31 126 432.64 126 432.64 116.09 428.31 116.09 428.31 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.26 116.09 275.26 126 279.6 126 279.6 116.09 275.26 116.09 275.26 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "436.12 116.09 436.12 126 440.46 126 440.46 116.09 436.12 116.09 436.12 116.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "259.19 134.78 259.19 138.6 263.59 138.6 263.59 134.78 259.19 134.78 259.19 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "420.05 134.78 420.05 138.6 424.45 138.6 424.45 134.78 420.05 134.78 420.05 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.41 134.78 267.41 138.6 271.82 138.6 271.82 134.78 267.41 134.78 267.41 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "428.27 134.78 428.27 138.6 432.68 138.6 432.68 134.78 428.27 134.78 428.27 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.24 134.78 275.24 138.6 279.65 138.6 279.65 134.78 275.24 134.78 275.24 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "436.1 134.78 436.1 138.6 440.51 138.6 440.51 134.78 436.1 134.78 436.1 134.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.47 138.72 54.86 138.72 54.86 135.17 60.47 135.17 60.47 138.72 60.47 138.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "682.47 138.72 676.86 138.72 676.86 135.17 682.47 135.17 682.47 138.72 682.47 138.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.17 138.72 36.56 138.72 36.56 135.17 42.17 135.17 42.17 138.72 42.17 138.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "664.17 138.72 658.56 138.72 658.56 135.17 664.17 135.17 664.17 138.72 664.17 138.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.28 138.72 17.67 138.72 17.67 135.17 23.28 135.17 23.28 138.72 23.28 138.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "645.28 138.72 639.67 138.72 639.67 135.17 645.28 135.17 645.28 138.72 645.28 138.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.52,58.48V50.91l-.77-.33v-4c0-.58-.24-2.77-1.69-3.18H253.65l0,11.38-3.86.86v2.8h-5.9a.81.81,0,0,1-.76-.58h0a2.36,2.36,0,0,0-4,0h0a.82.82,0,0,1-.77.58h-8.45a.83.83,0,0,1-.77-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h-9.52a.81.81,0,0,1-.76-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h-9.2a.83.83,0,0,1-.77-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h-9a.81.81,0,0,1-.76-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h0l-9,0h0a.8.8,0,0,1-.77-.57h0a2.36,2.36,0,0,0-4,0h0a.77.77,0,0,1-.76.54H156a.82.82,0,0,1-.77-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h-9.15a.83.83,0,0,1-.77-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h-9.58a.81.81,0,0,1-.76-.58h0a2.36,2.36,0,0,0-4,0h0a.82.82,0,0,1-.77.58h-9.29a.82.82,0,0,1-.77-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58H97.1a.81.81,0,0,1-.76-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58h-9a.83.83,0,0,1-.77-.58h0a2.36,2.36,0,0,0-4,0h0a.8.8,0,0,1-.76.58H69.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.49,58.48V50.91l.77-.33v-4c0-.72.31-2.79,1.69-3.18H446.36l0,11.38,3.86.86v2.8h5.92a.84.84,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h8.45a.82.82,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9.52a.81.81,0,0,0,.76-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9.2a.83.83,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9a.81.81,0,0,0,.76-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.77.58h0l9,0h0a.8.8,0,0,0,.77-.57h0a2.36,2.36,0,0,1,4,0h0a.77.77,0,0,0,.76.54H544a.82.82,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9.15a.83.83,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9.58a.83.83,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9.29a.82.82,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h8.87a.81.81,0,0,0,.76-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h9a.83.83,0,0,0,.77-.58h0a2.36,2.36,0,0,1,4,0h0a.8.8,0,0,0,.76.58h7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350,59.34h63.67m16.72,51.09H350m0-44.14h63.84M144.87,131H129.2m0-59.33h15.67M8.73,71.7H38.92m0-8.78H14.3M38.92,131H8.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.63,142.18V132M50.71,131V71.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 69.9,
    y1: 131.03,
    x2: 69.9,
    y2: 113.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 69.64,
    y1: 110.39,
    x2: 69.64,
    y2: 67.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,131V71.7M45.55,131V71.7M38.92,131H69.63M38.92,62.92H63.54M69.2,71.7H38.92m30.21,0H82.21m0,59.33H66.55m15.66,0H69.63m-.5-59.33v2.85M113.54,131H97.88m0-59.33h15.66M97.88,131H82.21m0-59.33H97.88M129.2,131H113.54m0-59.33H129.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.85,71.7h14.22m-1,59.33H238.85m-47,0H176.2m0-59.33h15.66M160.53,131H144.87m0-59.33h15.66M176.2,131H160.53m0-59.33H176.2m47,59.33H207.53m0-59.33h15.66M207.53,131H191.86m0-59.33h15.67M238.85,131H223.19m0-59.33h15.66M350,59.34H286.33M6.8,110.43H350M295.16,66.31v0m54.84,0H286.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.55,130.31H252.61m17-59H253.14m-.17-12h16.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 253.69,
    y1: 54.82,
    x2: 285.91,
    y2: 54.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M269.61,63.79H253.1m16.51,7.56h16.52m.13-12H269.61m0,4.45h16.51m-30.71,0h.66m-.66,0h.66m33.38,2.52v0m31,71.48h0m-8.54,4.4v-4.4m76.12,0H311.94m118.45-7.47h-17m17,0h17m-17-19.88H449M430.39,71.35h16.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 446.86,
    y1: 59.34,
    x2: 430.39,
    y2: 59.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 446.69,
    y1: 54.82,
    x2: 414.09,
    y2: 54.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 413.84,
    y1: 63.79,
    x2: 446.93,
    y2: 63.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.06,139.84v-2.06m0,4.4v-3.89m42.33-66.94H413.91m-.17-12h16.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 142.18 0 145.43 700 145.43 700 142.18 0 142.18 0 142.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57.36,53.62v9.3m-18.44-9.3v9.3m-18.44-9.3v9.3M27.13,131V71.7M32.29,131V71.7M13.87,131V71.7M693.2,110.43H350M570.8,71.7H555.13m0,59.33H570.8m90.28,0h30.48M661.08,62.92H692m-.62,8.78H661.08m25,59.33V71.7m-25,59.33H630.37m42.5,0V71.7M667.71,131V71.7M654.45,131V71.7M649.29,131V71.7M636,131V71.7M617.79,131h12.58m-12.58,0h15.66M630.87,71.7H617.79m13,0h30.28m0-8.78h-24.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 630.23,
    y1: 110.3,
    x2: 630.23,
    y2: 67.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 629.98,
    y1: 131.03,
    x2: 629.98,
    y2: 113.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M586.46,131h15.66m0,0h15.67m-47,0h15.66M602.12,71.7H586.46m31.33,0H602.12M447.9,131h13.25m0-59.33H447m76.83,0H508.14m0,59.33H523.8m15.67,0h15.66m-31.33,0h15.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 587.24,
    y1: 71.7,
    x2: 523.8,
    y2: 71.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M476.81,131h15.67m0,0h15.66m-47,0h15.66M492.48,71.7H461m47.15,0H492.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M389,48.23v6.6m14.23-6.6v6.6M366,48.23v6.6m14.22-6.6v6.6m-37.3-6.6v6.6m14.22-6.6v6.6m-37.3-6.6v6.6M334,48.23v6.6M311,48.23v6.6m-14.23-6.6v6.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "263.41 45.38 265.59 45.38 265.59 50.39 263.41 50.39 263.41 45.38 263.41 45.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "273.59 45.38 275.78 45.38 275.78 50.39 273.59 50.39 273.59 45.38 273.59 45.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "268.67 45.38 270.85 45.38 270.85 50.39 268.67 50.39 268.67 45.38 268.67 45.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "424.25 45.38 426.44 45.38 426.44 50.39 424.25 50.39 424.25 45.38 424.25 45.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "434.44 45.38 436.62 45.38 436.62 50.39 434.44 50.39 434.44 45.38 434.44 45.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "429.51 45.38 431.69 45.38 431.69 50.39 429.51 50.39 429.51 45.38 429.51 45.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.69,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.69,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.52,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.52,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.24,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.24,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.07,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.07,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.29,75.05a2.74,2.74,0,0,1,2.53,3v8.1H54.76v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.34,75.05a2.74,2.74,0,0,1,2.53,3v8.1H639.8v-8.1a2.74,2.74,0,0,1,2.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.83,75.05a2.74,2.74,0,0,1,2.54,3v8.1H658.3v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.33,75.05a2.75,2.75,0,0,1,2.54,3v8.1H676.8v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.34,93.38a2.74,2.74,0,0,1,2.53,3v8.1H639.8v-8.1a2.74,2.74,0,0,1,2.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.83,93.38a2.74,2.74,0,0,1,2.54,3v8.1H658.3v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.33,93.38a2.75,2.75,0,0,1,2.54,3v8.1H676.8v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.23,75.05a2.74,2.74,0,0,1,2.54,3v8.1H36.7v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.32,75.05a2.74,2.74,0,0,1,2.53,3v8.1H17.78v-8.1a2.74,2.74,0,0,1,2.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.29,93.36a2.74,2.74,0,0,1,2.53,3v8.1H54.76v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.23,93.36a2.74,2.74,0,0,1,2.54,3v8.1H36.7v-8.1a2.74,2.74,0,0,1,2.53-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.32,93.36a2.74,2.74,0,0,1,2.53,3v8.1H17.78v-8.1a2.74,2.74,0,0,1,2.54-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.45,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.45,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.28,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.28,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.83,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.83,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.21,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.21,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.76,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.76,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.58,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.58,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.8,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.8,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.52,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.52,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M590.34,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M590.34,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.73,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.73,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.55,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.55,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.27,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.27,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M605.1,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M605.1,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.15,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.15,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.48,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.48,93.36a4,4,0,0,1,4,4v7.1h-8v-7.1a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.31,75.81a4,4,0,0,1,4,4v7.09h-8V79.82a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.31,93.38a4,4,0,0,1,4,4v7.09h-8V97.39a4,4,0,0,1,4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.69,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51H76.4v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457.52,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.24,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51H165v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M546.07,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.31,115c1.23,0,2.51.19,2.51,2.79v8.65H55v-8.65c0-2.6,1-2.79,2.27-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M642.35,115c1.23,0,2.52.49,2.52,2.69v7h-4.79v-7c0-2.2,1-2.69,2.27-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M660.85,115c1.23,0,2.52.49,2.52,2.69v7h-4.79v-7c0-2.2,1-2.69,2.27-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.35,115c1.23,0,2.52.49,2.52,2.69v7h-4.79v-7c0-2.2,1-2.69,2.27-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.25,115c1.23,0,2.52.19,2.52,2.79v8.65H37v-8.65c0-2.6,1-2.79,2.27-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.33,115c1.23,0,2.52.29,2.52,2.89v8.55H18.07v-8.55c0-2.6,1-2.89,2.26-2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.45,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51H91.16v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.28,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51H469v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.83,115.84c2.2,0,3.22,1.65,3.22,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.3-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.21,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487,115.84c2.2,0,3.23,1.65,3.23,4.37v6.51h-6.53v-6.51c0-2.72,1.09-4.37,3.3-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.76,115.84c2.2,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575.58,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,115.84c2.2,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.8,115.84c2.2,0,3.22,1.65,3.22,4.37v6.51H498.5v-6.51c0-2.72,1.09-4.37,3.3-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.52,115.84c2.2,0,3.22,1.65,3.22,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.3-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M590.34,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.73,115.84c2.2,0,3.22,1.65,3.22,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.3-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.55,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.27,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51H224v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M605.1,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.08-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.15,115.84c2.2,0,3.22,1.65,3.22,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.3-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M619,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.48,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51h-6.52v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M531.31,115.84c2.21,0,3.23,1.65,3.23,4.37v6.51H528v-6.51c0-2.72,1.09-4.37,3.29-4.37Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 69.83,
    y1: 66.81,
    x2: 253.05,
    y2: 66.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 446.93,
    y1: 66.84,
    x2: 630.17,
    y2: 66.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 285.99,
    y1: 54.81,
    x2: 414.16,
    y2: 54.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.29,62.91v-12l-.78-.33,0-4c0-1.22-.51-3.25-2.17-3.25s-2.2,1.89-2.21,3.26v4l-.79.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M685.72,62.91v-12l.78-.33,0-4c0-1.22.51-3.25,2.17-3.25s2.2,1.89,2.21,3.26v4l.79.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M32.67,62.91v-12l-.77-.33,0-4c0-1.22-.51-3.25-2.18-3.25s-2.19,1.89-2.2,3.26v4l-.79.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M667.34,62.91v-12l.77-.33,0-4c0-1.22.51-3.25,2.18-3.25s2.19,1.89,2.2,3.26v4l.79.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M51.1,62.91v-12l-.77-.33v-4c0-1.22-.55-3.25-2.22-3.25s-2.19,1.89-2.2,3.26v4l-.79.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M648.91,62.91v-12l.77-.33v-4c0-1.22.54-3.25,2.21-3.25s2.19,1.89,2.2,3.26v4l.79.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M69.53,62.91v-12l-.77-.33v-4c0-1.22-.54-3.25-2.21-3.25s-2.2,1.89-2.21,3.26v4l-.78.24V62.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M630.48,62.91v-12l.77-.33v-4c0-1.22.54-3.25,2.21-3.25s2.2,1.89,2.21,3.26v4l.78.24V62.91Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "8.32 62.91 8.01 62.91 8.01 67.07 8.72 67.07 8.72 110.42 6.79 110.42 6.79 113.07 8.46 113.07 8.46 131.03 7.2 131.97 7.2 142.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "691.69 62.91 692 62.91 692 67.07 691.29 67.07 691.29 110.42 693.22 110.42 693.22 113.07 691.55 113.07 691.55 131.03 692.81 131.97 692.81 142.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "14.28 62.91 14.59 62.91 14.59 67.07 13.88 67.07 13.88 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "685.73 62.91 685.43 62.91 685.43 67.07 686.13 67.07 686.13 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "32.68 62.91 32.98 62.91 32.98 67.07 32.28 67.07 32.28 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "667.34 62.91 667.03 62.91 667.03 67.07 667.74 67.07 667.74 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "51.11 62.91 51.41 62.91 51.41 67.07 50.71 67.07 50.71 71.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M648.9,62.91h-.3v4.16h.7v4.68M26.75,62.91h-.31v4.16h.71v4.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "673.26 62.91 673.57 62.91 673.57 67.07 672.86 67.07 672.86 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "45.14 62.91 44.84 62.91 44.84 67.07 45.54 67.07 45.54 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "654.87 62.91 655.17 62.91 655.17 67.07 654.47 67.07 654.47 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "63.57 62.91 63.26 62.91 63.26 67.07 63.97 67.07 63.97 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "636.45 62.91 636.75 62.91 636.75 67.07 636.04 67.07 636.04 71.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "69.52 62.91 69.83 62.91 69.83 67.07 69.12 67.07 69.12 110.42 71.05 110.42 71.05 113.07 69.38 113.07 69.38 131.03 70.64 131.97 70.64 142.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "630.49 62.91 630.18 62.91 630.18 67.07 630.89 67.07 630.89 110.42 628.96 110.42 628.96 113.07 630.63 113.07 630.63 131.03 629.37 131.97 629.37 142.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M661.08,53.6v9.31m18.43-9.31v9.31M642.78,53.6v9.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M259.87,54.8V42.7a9,9,0,0,0-3.14-6.94,9.33,9.33,0,0,0-3.08,6.94V54.8l-3.84.86v3.65h3.3v45.47h-1.33V113h.86V130.3l-1.18,1.58V142.2M420.62,54.81V42.64a8.92,8.92,0,0,0-3.14-6.94,9.3,9.3,0,0,0-3.08,6.94V54.81l-3.84.78v3.77h3.3v45.36h-1.32v8.19h.85v17.32l-1.18,1.59v10.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M279.38,54.8V42.7a8.93,8.93,0,0,1,3.15-6.94,9.4,9.4,0,0,1,3.08,6.94V54.8l3.84.86v3.67h-3.3v45.45h1.32V113h-.86V130.3l1.19,1.58V142.2M440.13,54.74V42.64a8.94,8.94,0,0,1,3.15-6.94,9.34,9.34,0,0,1,3.08,6.94l0,12.18,3.86.86v3.58h-3.3v45.46h1.32v8.19h-.86v17.32l1.19,1.59v10.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.16 106.12 289.16 110.43 295.48 110.43 295.48 106.12 294.54 103.77 294.34 73.16 290.37 73.16 290.17 103.83 289.16 106.12 289.16 106.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "312.23 106.12 312.23 110.43 318.55 110.43 318.55 106.12 317.61 103.77 317.41 73.16 313.44 73.16 313.24 103.83 312.23 106.12 312.23 106.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "335.3 106.12 335.3 110.43 341.62 110.43 341.62 106.12 340.68 103.77 340.48 73.16 336.51 73.16 336.31 103.83 335.3 106.12 335.3 106.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "358.44 106.12 358.44 110.43 364.76 110.43 364.76 106.12 363.81 103.77 363.61 73.16 359.65 73.16 359.44 103.83 358.44 106.12 358.44 106.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "381.5 106.12 381.5 110.43 387.83 110.43 387.83 106.12 386.88 103.77 386.68 73.16 382.71 73.16 382.51 103.83 381.5 106.12 381.5 106.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "404.57 106.12 404.57 110.43 410.89 110.43 410.89 106.12 409.95 103.77 409.75 73.16 405.78 73.16 405.58 103.83 404.57 106.12 404.57 106.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66,43.45H60.89l-12.5-17v-5.5L48,19.59l-1-.95-.1-.1-.17-.12-.18.12-.1.1-.91.84-.42,1.18H32.67l-.42-1.18-.91-.84-.1-.1-.18-.12-.17.12-.1.1-1,.95-.36,1.33v5.5h-.06L13.5,48.27v2.31l.78.33v2.71H26.7V50.85l.79-.24v-4c.07-3.05,1.68-3.26,2.2-3.26s2.07.29,2.18,3.25l0,4,.77.33v2.71H45.12V50.85l.79-.24v-4c.07-3,1.63-3.3,2.2-3.26s2.13.35,2.22,3.25v4l.77.33v2.71H63.56V50.85l.78-.24v-2h0v-2c0-.88.23-2.72,1.62-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M634.05,43.45h5.07l12.5-17v-5.5l.36-1.33,1-.95.1-.1.17-.12.18.12.1.1.91.84.42,1.18h12.5l.42-1.18.91-.84.11-.1.17-.12.17.12.1.1,1,.95.37,1.33v5.5h0l15.89,21.85v2.31l-.78.33v2.71H673.31V50.85l-.79-.24v-4c-.06-3.05-1.68-3.26-2.2-3.26s-2.07.29-2.18,3.25l0,4-.77.33v2.71H654.89V50.85l-.79-.24v-4c-.07-3-1.63-3.3-2.2-3.26s-2.13.35-2.21,3.25v4l-.77.33v2.71H636.45V50.85l-.78-.24v-2h0v-2c0-.88-.23-2.72-1.62-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M386.51,121.67h-3.15a10.33,10.33,0,0,0-20.54,0h-2.56a10.33,10.33,0,0,0-20.54,0h-2.56a10.33,10.33,0,0,0-20.54,0h-3.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M412.55,142.17V110.51m35.67,31.62V110.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 412.54,
    y1: 110.4,
    x2: 412.54,
    y2: 66.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 448.22,
    y1: 110.42,
    x2: 448.22,
    y2: 59.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M287.44,142.17V110.51m-35.67,31.62V110.47"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 287.45,
    y1: 110.4,
    x2: 287.45,
    y2: 66.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 251.77,
    y1: 110.42,
    x2: 251.77,
    y2: 59.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M499.24,58.48v8.36m14.44-8.36v8.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 528.38,
    y1: 58.5,
    x2: 528.38,
    y2: 66.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M543.53,58.48v8.36m14.54-8.36v8.36m15-8.36v8.36M588,58.48v8.36m14.42-8.36v8.36m14.51-8.36v8.36M484.44,58.48v8.36m-14.89-8.36v8.36m-14-8.36v8.36m50.34-8.36v8.36m14.43-8.36v8.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 534.99,
    y1: 58.5,
    x2: 534.99,
    y2: 66.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M550.13,58.48v8.36m14.55-8.36v8.36m15-8.36v8.36m14.91-8.36v8.36M609,58.48v8.36m14.52-8.36v8.36M491,58.48v8.36m-14.88-8.36v8.36m-14-8.36v8.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 120.14,
    y1: 58.48,
    x2: 120.14,
    y2: 66.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M135.5,58.48v8.35M150,58.48v8.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M165.19,58.48v8.35m14.54-8.35v8.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M194.28,58.52v8.31m14.54-8.31v8.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M223.85,58.48v8.35m14.06-8.35v8.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 105.49,
    y1: 58.48,
    x2: 105.49,
    y2: 66.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M91.13,58.48v8.35M76.49,58.48v8.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M126.74,58.48v8.35m15.36-8.35v8.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M156.61,58.48v8.35m15.18-8.35v8.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M186.34,58.52v8.31m14.54-8.31v8.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M215.43,58.48v8.35m15-8.35v8.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 244.52,
    y1: 58.48,
    x2: 244.52,
    y2: 66.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 112.09,
    y1: 58.48,
    x2: 112.09,
    y2: 66.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 97.74,
    y1: 58.52,
    x2: 97.74,
    y2: 66.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 83.09,
    y1: 58.48,
    x2: 83.09,
    y2: 66.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.75,186.11a5.81,5.81,0,0,0,1.86-4.54V166.92a29.73,29.73,0,0,1,.32-4.39q-.67,2.41-1.38,4.5l-5.89,17.22a4.1,4.1,0,0,0-.08,1.86H18.31a4.71,4.71,0,0,0,.07-.84,3.13,3.13,0,0,0-.15-1L12.3,167c-.51-1.47-1-3-1.37-4.5a19.9,19.9,0,0,1,.41,4.39v14.65a5.81,5.81,0,0,0,1.87,4.54H6.31a5.81,5.81,0,0,0,1.86-4.54v-17.4a5.74,5.74,0,0,0-1.86-4.48h7.52a1.39,1.39,0,0,0-.28.8,1,1,0,0,0,0,.26l5.77,16.75a32.34,32.34,0,0,1,1.21,4.91,37.18,37.18,0,0,1,1.2-4.91l5.7-16.75a.18.18,0,0,1,0-.06.83.83,0,0,0,.06-.28,6.49,6.49,0,0,0-.22-.72h7.56a5.72,5.72,0,0,0-1.82,4.48v17.4a5.8,5.8,0,0,0,1.82,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.14,164.17a5.74,5.74,0,0,0-1.86-4.48h7.24a5.74,5.74,0,0,0-1.86,4.48V177c0,2.31.35,3.95,1,4.9q1.23,1.69,4.51,1.7t4.52-1.7c.67-.94,1-2.58,1-4.9v-12.8a5.75,5.75,0,0,0-1.88-4.48h7A5.7,5.7,0,0,0,87,164.17v12.54q0,5.07-1.3,6.89c-1.45,2-4,3.05-7.66,3.05s-6.2-1-7.6-3.05q-1.31-1.87-1.31-6.89V164.17ZM79.62,157l3.23-5.27c.58-1,1.2-1.42,1.84-1.42A1.18,1.18,0,0,1,86,151.68a2.71,2.71,0,0,1-1.17,1.82L80.73,157Zm-4.56,0,2.47-5.1c.53-1.06,1.12-1.59,1.79-1.59a1.26,1.26,0,0,1,.92.41,1.3,1.3,0,0,1,.42.94,2.87,2.87,0,0,1-1,1.73L76.2,157Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.47,159.69a4.51,4.51,0,0,0,2.59-.91v8.67a7.58,7.58,0,0,0-3.83-4.1,13.61,13.61,0,0,0-5.61-1,6.44,6.44,0,0,0-2.8.44,2.41,2.41,0,0,0-1.24,2.34v5.64h4.72a5.82,5.82,0,0,0,4.95-2.36v7.49a5.82,5.82,0,0,0-4.95-2.36h-4.72v6.83a2.54,2.54,0,0,0,1.36,2.52,7.4,7.4,0,0,0,3,.45,14,14,0,0,0,5.94-1,8.65,8.65,0,0,0,3.94-4.38v9a4.61,4.61,0,0,0-2.79-.88H121.2a5.81,5.81,0,0,0,1.86-4.54v-17.4a5.74,5.74,0,0,0-1.86-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.7,187a3.2,3.2,0,0,0-2.58-1.38,15,15,0,0,0-3.24.52,15.09,15.09,0,0,1-3.28.52q-11,0-11-13.11,0-6.25,2.4-9.95,2.88-4.44,8.79-4.44a14.58,14.58,0,0,1,2.87.42,14.45,14.45,0,0,0,2.84.42,3.55,3.55,0,0,0,2.32-1v10.16a18.86,18.86,0,0,0-3.2-4.78,7,7,0,0,0-5.12-2.12,6.13,6.13,0,0,0-5.79,3.74,16.11,16.11,0,0,0-1.43,7.2,15.29,15.29,0,0,0,1.43,7,6,6,0,0,0,5.65,3.59,6.91,6.91,0,0,0,3.94-1.08,3.94,3.94,0,0,0,1.86-3.46v-2.44a5.29,5.29,0,0,0-2.24-4.51h6.8c-.68.88-1,2.38-1,4.51V187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241,163.8a5.63,5.63,0,0,0,.77-2.37,2.65,2.65,0,0,0-.89-1.74h6.78a15.26,15.26,0,0,0-2.69,3.64l-7.12,13.41v4.83a5.8,5.8,0,0,0,1.82,4.54h-7.23a5.84,5.84,0,0,0,1.85-4.54v-4.64l-7.15-13.6a14.91,14.91,0,0,0-2.66-3.64h7.23a2.54,2.54,0,0,0-.84,1.74,5.69,5.69,0,0,0,.73,2.37l4.64,9.4,4.76-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.9,159.69a4.48,4.48,0,0,0,2.58-.91v8.67a7.58,7.58,0,0,0-3.83-4.1,13.54,13.54,0,0,0-5.61-1,6.39,6.39,0,0,0-2.79.44,2.42,2.42,0,0,0-1.25,2.34v5.64h4.73a5.79,5.79,0,0,0,4.94-2.36v7.49a5.79,5.79,0,0,0-4.94-2.36H283v6.83a2.54,2.54,0,0,0,1.36,2.52,7.46,7.46,0,0,0,3.05.45,14,14,0,0,0,5.93-1,8.61,8.61,0,0,0,3.94-4.38v9a4.57,4.57,0,0,0-2.79-.88H277.63a5.81,5.81,0,0,0,1.86-4.54v-17.4a5.74,5.74,0,0,0-1.86-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341,181.57a5.8,5.8,0,0,0,1.82,4.54h-7.2a5.8,5.8,0,0,0,1.82-4.54V164.79c0-1.65-.7-2.48-2.1-2.48q-4.26,0-6,6.06v-9.59a3.07,3.07,0,0,0,2,.91h15.88a3,3,0,0,0,2-.91v9.59q-1.74-6.06-6-6.06c-1.42,0-2.12.83-2.12,2.48v16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M397.05,159.69a4.51,4.51,0,0,0,2.59-.91v8.67a7.59,7.59,0,0,0-3.84-4.1,13.54,13.54,0,0,0-5.61-1,6.42,6.42,0,0,0-2.79.44,2.41,2.41,0,0,0-1.24,2.34v5.64h4.72a5.79,5.79,0,0,0,4.94-2.36v7.49a5.79,5.79,0,0,0-4.94-2.36h-4.72v6.83a2.54,2.54,0,0,0,1.36,2.52,7.4,7.4,0,0,0,3,.45,14,14,0,0,0,5.94-1,8.65,8.65,0,0,0,3.94-4.38v9a4.61,4.61,0,0,0-2.79-.88H380.78a5.81,5.81,0,0,0,1.86-4.54v-17.4a5.74,5.74,0,0,0-1.86-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.84,186.11a5.81,5.81,0,0,0,1.86-4.54V166.92a29.73,29.73,0,0,1,.32-4.39q-.67,2.41-1.38,4.5l-5.9,17.22a3.13,3.13,0,0,0-.15,1,3,3,0,0,0,.08.84H445.4a4.71,4.71,0,0,0,.07-.84,3.43,3.43,0,0,0-.15-1L439.39,167q-.76-2.21-1.38-4.5a19.31,19.31,0,0,1,.41,4.39v14.65a5.82,5.82,0,0,0,1.88,4.54h-6.9a5.81,5.81,0,0,0,1.86-4.54v-17.4a5.74,5.74,0,0,0-1.86-4.48h7.51a1.37,1.37,0,0,0-.27.8,1,1,0,0,0,0,.26l5.78,16.75a34.9,34.9,0,0,1,1.21,4.91,34.26,34.26,0,0,1,1.2-4.91l5.69-16.75,0-.06a.83.83,0,0,0,.06-.28s-.08-.28-.23-.72H462a5.72,5.72,0,0,0-1.82,4.48v17.4a5.8,5.8,0,0,0,1.82,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.48,167.41h-2.4a3,3,0,0,0-2,.61v-3.89a4.7,4.7,0,0,0,2,.5c2.16,0,3.24-1.2,3.24-3.62a4.58,4.58,0,0,0-.37-1.86h3.34a9.65,9.65,0,0,0-.39,2.94v19.48a5.78,5.78,0,0,0,1.85,4.54h-7.13a5.8,5.8,0,0,0,1.82-4.54V167.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.62,186.11a19.05,19.05,0,0,0,4.27-7.23l4.8-13.33A4.8,4.8,0,0,0,586,164c0-1.31-1.06-2-3.2-2q-6.51,0-9.74,6.19v-9.43a5.07,5.07,0,0,0,2.83.88h16.83a14.93,14.93,0,0,0-3.28,5.48l-5.52,15.27a8.66,8.66,0,0,0-.62,2.81,4.07,4.07,0,0,0,1.34,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.77,171.79a6.69,6.69,0,0,1,4.45,6.74,7.24,7.24,0,0,1-3,6.3,11.92,11.92,0,0,1-7,1.82,11.79,11.79,0,0,1-6.94-1.84,7.19,7.19,0,0,1-3-6.28,6.69,6.69,0,0,1,4.42-6.74,5.61,5.61,0,0,1-3.38-5.56,6.23,6.23,0,0,1,2.71-5.5,12.82,12.82,0,0,1,12.33,0,6.2,6.2,0,0,1,2.73,5.5,5.62,5.62,0,0,1-3.42,5.56Zm-5.48-9.85a6.42,6.42,0,0,0-3.72,1,3.83,3.83,0,0,0-1.62,3.35,3.93,3.93,0,0,0,1.6,3.4,7.39,7.39,0,0,0,7.49,0,3.89,3.89,0,0,0,1.62-3.4,3.82,3.82,0,0,0-1.64-3.35,6.43,6.43,0,0,0-3.73-1Zm0,11.45a7.58,7.58,0,0,0-4.46,1.18,5.21,5.21,0,0,0,0,8.1,9,9,0,0,0,9,0,5.2,5.2,0,0,0,0-8.08,7.52,7.52,0,0,0-4.46-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.18,186.73a.59.59,0,0,0,0-.14c0-.61-.06-1.08-.06-1.39a13,13,0,0,1,5.48-10.79c1.18-.82,3.25-2.38,6.21-4.64q2.4-1.94,2.4-4A3.32,3.32,0,0,0,688,163a4.59,4.59,0,0,0-3-.9q-5.47,0-9,6.77V159A3.78,3.78,0,0,0,678.6,160a19.47,19.47,0,0,0,3.38-.46,18.91,18.91,0,0,1,3.44-.46,7.86,7.86,0,0,1,5.2,1.64,6.06,6.06,0,0,1,2.1,4.94,7.59,7.59,0,0,1-1.13,4,8.53,8.53,0,0,1-1.86,1.8l-3.59,2.9-.11.1c-1.07.86-2.85,2.3-5.31,4.35a4.34,4.34,0,0,0-1.36,2.77c0,.93.58,1.52,1.72,1.77a16.61,16.61,0,0,0,2.82.15c3,0,5.1-.54,6.32-1.6q1.56-1.38,3.34-5.71V187a3.62,3.62,0,0,0-2.32-.88h-14a3.26,3.26,0,0,0-2,.62Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBme);
export default __webpack_public_path__ + "static/media/bme.c84f271596460ed5cec78cfb859e0c94.svg";
export { ForwardRef as ReactComponent };